/* Monarchia: coming soon scramble text */
(function () {
  'use strict';
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789#/\\<>+=_';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(el) {
    if (el.__mnrSoon) return;
    el.__mnrSoon = true;
    var phrases = (el.getAttribute('data-phrases') || el.textContent).split('|');
    if (reduce || phrases.length < 1) return;

    var idx = 0, timer = null, raf = null, visible = true;

    function scramble(to, done) {
      var from = el.textContent, len = Math.max(from.length, to.length), frame = 0, total = 34;
      var queue = [];
      for (var i = 0; i < len; i++) {
        var start = Math.floor(Math.random() * 14);
        queue.push({ to: to[i] || '', start: start, end: start + 8 + Math.floor(Math.random() * 14) });
      }
      el.classList.add('is-glitch');
      setTimeout(function () { el.classList.remove('is-glitch'); }, 300);
      (function tick() {
        var out = '', complete = 0;
        for (var j = 0; j < queue.length; j++) {
          var q = queue[j];
          if (frame >= q.end) { complete++; out += q.to; }
          else if (frame >= q.start) { out += q.to === ' ' ? ' ' : GLYPHS.charAt(Math.floor(Math.random() * GLYPHS.length)); }
          else { out += from[j] || ''; }
        }
        el.textContent = out;
        frame++;
        if (complete < queue.length && frame < total + 20) { raf = requestAnimationFrame(tick); }
        else { el.textContent = to; if (done) done(); }
      })();
    }

    function next() {
      if (!visible || document.hidden) { timer = setTimeout(next, 1000); return; }
      idx = (idx + 1) % phrases.length;
      scramble(phrases[idx], function () { timer = setTimeout(next, 3200); });
    }

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(el);
    }
    // first reveal: scramble in from noise
    el.textContent = phrases[0].replace(/[^ ]/g, '_');
    scramble(phrases[0], function () { timer = setTimeout(next, 3200); });
  }

  function boot() {
    var nodes = document.querySelectorAll('[data-mnr-scramble]');
    for (var i = 0; i < nodes.length; i++) init(nodes[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
